import React from "react";

function VoiceEvacualtion() {
  return (
    <div class="col-lg-8 col-md-12 col-sm-12 content-side">
      <div class="service-details-content">
        <div class="inner-box">
          <h2>Voice Evacuation System</h2>
          <figure class="image-box">
            <img
              src="/assets/images/voice-evacuation-system-large.jpg"
              alt=""
            />
          </figure>
          <div class="text">
            <h4>Integrated Voice Evacuation System</h4>

            <p>
              An ‘Integrated Voice Evacuation Life Safety System’ is often a
              more effective, faster, and safer means of evacuating and/or
              communicating to occupants in the event of an emergency. It is
              designed as part of a distributed intelligence system and
              increases the chances of survival tremendously. In the system, an
              activated fire alarm signal from any precise location in the
              building is immediately notified to the ‘fire alarm panel’. When
              this occurs, local or customized voice evacuation messages will be
              announced automatically on the public address system as per the
              programming in the ‘fire alarm panel’.
            </p>
            <h4>Addressable Two Way Talkback System</h4>
            <p>
              In an ‘Addressable Talk Back System’, the occupant or fire brigade
              personnel can communicate to the ‘control command center’ through
              a handset telephone by plugging into the telephone jacks provided
              on all the floors. This enables the command center and the caller
              to communicate simultaneously.
            </p>
            <h4>Conventional Talk Back Systems</h4>
            <p>
              In a ‘Conventional Talk Back System’, the operator can select a
              particular zone or all zones (‘All Call’ mode) through a keypad.
              The operator can then announce a stage-wise evacuation message in
              ‘Press to Talk’ mode, and can also listen to occupants in ‘Listen’
              mode.
            </p>
          </div>
     
        </div>
      </div>
    </div>
  );
}

export default VoiceEvacualtion;
